import Phaser from "phaser";

let installed = false;

export function installRetinaTextPatch() {
  if (installed) return;
  installed = true;

  const dpr = Math.max(1, window.devicePixelRatio || 1);
  if (dpr <= 1) return;

  const proto = Phaser.GameObjects.GameObjectFactory.prototype as unknown as {
    text(x: number, y: number, text: string | string[], style?: Phaser.Types.GameObjects.Text.TextStyle): Phaser.GameObjects.Text;
  };
  const origText = proto.text;
  proto.text = function (x, y, text, style) {
    const merged: Phaser.Types.GameObjects.Text.TextStyle = { ...(style ?? {}) };
    if (merged.resolution === undefined) merged.resolution = dpr;
    return origText.call(this, x, y, text, merged);
  };

  const OrigTextCtor = Phaser.GameObjects.Text;
  const PatchedText = function (
    this: Phaser.GameObjects.Text,
    scene: Phaser.Scene,
    x: number,
    y: number,
    text: string | string[],
    style?: Phaser.Types.GameObjects.Text.TextStyle,
  ) {
    const merged: Phaser.Types.GameObjects.Text.TextStyle = { ...(style ?? {}) };
    if (merged.resolution === undefined) merged.resolution = dpr;
    return new OrigTextCtor(scene, x, y, text, merged);
  } as unknown as typeof Phaser.GameObjects.Text;
  PatchedText.prototype = OrigTextCtor.prototype;
  (Phaser.GameObjects as unknown as { Text: typeof Phaser.GameObjects.Text }).Text = PatchedText;
}
